<template>
  <div>
    <rights-docs />
    <akkred />
  </div>
</template>

<script>
import RightsDocs from './components/RightsDocs'
import Akkred from './components/Accred'
export default {
  name: 'app',
  components: {
    'rights-docs': RightsDocs,
    'akkred': Akkred
  },
  created () {
  }

}
</script>

<style lang="less">
</style>
